export default {
  myAward: process.env.BASE_URL + '/api/modules/turntable/my_awards',
  getAward: process.env.BASE_URL + '/api/modules/turntable/get_award',
  awardList: process.env.BASE_URL + '/api/modules/turntable/award_list',
  signUp: process.env.BASE_URL + '/api/modules/turntable/submit'
}